import type { RouteObject } from 'react-router';
import type { RouteHandle } from '@/hooks/useRouteHandle';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

export const calendarRoutes: RouteObject[] = [
  {
    path: 'calendar',
    lazy: page('CalendarPage'),
    handle: { title: '캘린더', feature: 'CALENDAR' } satisfies RouteHandle,
  },
];
